module.exports = "/static/assets/424371873bc8df88d6a305d8727157ab.svg";